"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KnockNotificationItemList = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _KnockNotificationItemList = require("./KnockNotificationItemList.styled");
var _KnockPropTypes = require("../../KnockPropTypes");
var _KnockNotificationItem = require("../KnockNotificationItem");
var _KnockTypes = require("../../../../constants/KnockTypes");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var KnockNotificationItemList = exports.KnockNotificationItemList = function KnockNotificationItemList(_ref) {
  var isPopoverOpen = _ref.isPopoverOpen,
    knocks = _ref.knocks,
    targetElementId = _ref.targetElementId,
    onApprove = _ref.onApprove,
    onDeny = _ref.onDeny,
    cameraSources = _ref.unassignedCameraPresenters,
    screenShareSources = _ref.unassignedScreenSharePresenters,
    maxCamerasExceeded = _ref.maxCamerasExceeded,
    onAVClicked = _ref.onAVClicked,
    liveCameras = _ref.liveCameras,
    trigger = _ref.trigger,
    getItemDisabledState = _ref.getItemDisabledState;
  var handleApproveKnock = function handleApproveKnock(knock) {
    return function (sourceId) {
      return onApprove(_objectSpread(_objectSpread({}, knock), {}, {
        sourceId: sourceId
      }));
    };
  };
  var popoverProps = trigger ? {
    trigger: trigger
  } : {
    isOpen: isPopoverOpen
  };
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  (0, _react.useEffect)(function () {
    setIsOpen(isPopoverOpen);
  }, [isPopoverOpen]);
  return /*#__PURE__*/_react["default"].createElement(_KnockNotificationItemList.NotificationItemListPopover, (0, _extends2["default"])({
    placement: "bottom",
    target: targetElementId
  }, popoverProps, {
    isOpen: isOpen
  }), /*#__PURE__*/_react["default"].createElement(_KnockNotificationItemList.NotificationItemListContent, null, knocks.slice(0, 3).map(function (knock) {
    return /*#__PURE__*/_react["default"].createElement(_KnockNotificationItem.KnockNotificationItem, {
      key: knock._id,
      knock: knock,
      onApprove: handleApproveKnock(knock),
      sources: knock.type === _KnockTypes.PRESENTER ? cameraSources : screenShareSources,
      maxCamerasExceeded: maxCamerasExceeded,
      onAVClicked: onAVClicked,
      liveCameras: liveCameras,
      onDeny: onDeny.bind(null, knock),
      isDisabled: getItemDisabledState(knock)
    });
  })));
};
KnockNotificationItemList.propTypes = {
  isPopoverOpen: _propTypes["default"].bool,
  targetElementId: _propTypes["default"].string,
  knocks: _propTypes["default"].arrayOf(_KnockPropTypes.KnockPropTypes),
  onApprove: _propTypes["default"].func,
  onDeny: _propTypes["default"].func,
  unassignedCameraPresenters: _propTypes["default"].array,
  unassignedScreenSharePresenters: _propTypes["default"].array,
  maxCamerasExceeded: _propTypes["default"].bool,
  onAVClicked: _propTypes["default"].func,
  liveCameras: _propTypes["default"].number,
  trigger: _propTypes["default"].string,
  // Props for testing purposes
  getItemDisabledState: _propTypes["default"].func
};